import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as login from "../services/loginAPI";

import * as geo from "../services/geoCodeApi";
import * as loginOTP from "../services/loginOtpAPI";
import getDropDownOptions from "../utils/constants/SelectVariables";
const _ = require("lodash");


export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (params) => login.forgotPassword(params),
    retry: false,
  });
};

export const useVerifyOTP = () => {
  return useMutation({
    mutationFn: (params) => login.verifyOTP(params),
    retry: false,
  });
};
export const useResetPassword = () => {
  return useMutation({
    mutationFn: (params) => login.resetPassword(params),
    retry: false,
  });
};
export const useGeoLocations = (params) => {
  return useQuery({
    queryKey: ["locations", params],
    queryFn: () => geo.getProperLocation(params),
    enabled: !!params?.address,
  });
};
export const useSendLoginOTP = () => {
  return useMutation({
    mutationFn: (params) => login.sendLoginOTP(params),
    retry: false,
  });
};
//* Get Specialisation
export const useGetspecialisationlist = (params) => {
  return useQuery({
    queryKey: ["Specialization-List", params],
    queryFn: () => login.getspecialisationlist(),
    retry: true,
    select: (data) => {
      return {
        ...data,
        doctorSpecialisationList: getDropDownOptions(
          "specialisationlistDropdown",
          data.doctorSpecialisationList || []
        ),
      };
    },
  });
};

// export const useGetValidateMobileNumber = () => {
//   return useMutation((params) => login.getValidateMobileNumber(params), {
//     retry: false,
//   });
// };

// export const useGetValidateMobileNumber = (params) => {
//   return useQuery(["Login-OTP", params], () => login.getValidateMobileNumber(params), {
//     enabled: !_.isEmpty(params?.username),
//     retry: false,
//   });
// };

export const useValidateMobileNumberMutation = () => {
  return useMutation({
    mutationFn: (params) => login.getValidateMobileNumber(params),
    retry: false,
  });
};

export const useVerifyLoginOTP = () => {
  return useMutation({
    mutationFn: (params) => login.doctorVerifyOTP(params),
    retry: false,
  });
};

//* Get Provider specialization
export const useGetListOfSelectedSpecializationV1 = () => {
  return useQuery({
    queryKey: ["Selected-Spec"],
    queryFn: () => login.getListOfSelectedSpecializationV1(),
    enabled: true, // always fetch immediately
    retry: true,
  });
};

export const usePatientData = () => {
  return useMutation({
    mutationFn: (params) => login.sendpatientData(params),
    retry: false,
  });
};

//* Login With OTP
export const useLoginWithOTP = (params) => {
  return useQuery({
    queryKey: ["Login-OTP", params],
    queryFn: () => loginOTP.loginWIthOTP(params),
    enabled: !_.isEmpty(params?.username),
    retry: false,
  });
};
